import * as Promise from "es6-promise";
Promise.polyfill();
import * as Array from "../Helpers/Array.ts";
Array.polyfill();
import "intl";
import "intl/locale-data/jsonp/en-US";
import objectFitImages from "object-fit-images";
objectFitImages();
import "element-closest";
/*
 * https://github.com/birdy-/polyfill-formaction
 * Implement formaction HTML5 attribute.
 * Needs addEventListener polyfill for IE7/IE8
 */
(function () {
    window.addEventListener('load', function () {
        if (!("formAction" in document.createElement("input"))) {
            var elements = document.querySelectorAll('button');
            if (elements) {
                for (var i = 0; i < elements.length; i++) {
                    var element = elements[i];
                    if (element.attributes.formAction) {
                        element.addEventListener('click', function () {
                            if (this.form) {
                                this.form.action = this.attributes.formAction.value;
                            }
                            return true;
                        });
                    }
                }
            }
        }
    });
})();



//////////////////
// WEBPACK FOOTER
// ./src/App/Pollyfills.ts
// module id = 942
// module chunks = 24